import { render } from "./Lists.vue?vue&type=template&id=618d6310"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__